import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import { mainContext } from '../../MainContext';
import ContainerHead from './head/ContainerHead';
import ContainerPresent from './present/ContainerPresent';
import ContainerLink from './link/ContainerLink';
import ContainerShidou from './shidou/ContainerShidou';
import ContainerCustomer from './customer/ContainerCustomer';
import ContainerLesson from './lesson/ContainerLesson';
import ContainerProfile from './profile/ContainerProfile';
import ContainerLetter from './letter/ContainerLetter';


function Container() {
  const { t } = useTranslation();

  const isWide = useContext(mainContext).isWide;
  const footerWrapHeight = useContext(mainContext).footerWrapHeight;
  const footerHeight = useContext(mainContext).footerHeight;

  const [wrapMarginBottom, setWrapMarginBottom] = useState(0);


  useEffect(() => {
    let fHeight = footerWrapHeight;
    if(isWide) {
      fHeight += footerHeight + 50;
    }
    setWrapMarginBottom(fHeight);
  }, [isWide, footerWrapHeight, footerHeight])


  return (
    <div id="container" className="container container-lg container-md">

      <ContainerHead />


      <div
        className="main-wrap bg-white col-md-10 ms-auto me-auto pt-4"
        style={{marginBottom: wrapMarginBottom}}
      >

        <ContainerPresent />
        <ContainerLink />
        <ContainerShidou />
        <ContainerCustomer />
        <ContainerLesson />
        <ContainerPresent />
        <ContainerProfile />
        <ContainerLetter />

      </div>
      

    </div> 
  );
}

export default Container;